import { getPostRequestFetchOptions } from "../legacyClients";

// tslint:disable
export enum ClientBlobBucketName {
  CompetitionSubmissions = "competitionSubmissions",
  DatasetVersionFilesV2 = "datasetVersionFilesV2",
  InboxFiles = "inboxFiles",
  ForumMessageAttachmentFiles = "forumMessageAttachmentFiles",
  KernelSessionFiles = "kernelSessionFiles",
}

// Copied from old roslyn types: Kaggle.Blobs.Dtos
export interface StartCreateNewBlobFileDto {
  createUrl: string;
  token: string;
}

export interface CreateNewBlobRequestDto {
  contentLength: number;
  contentType: string;
  lastModifiedDate: Date | null | undefined;
  name: string;
}

export type CreateNewBlobHandler = (
  route: { blobBucket: string },
  request: CreateNewBlobRequestDto
) => Promise<StartCreateNewBlobFileDto>;

export interface BlobFilesClient {
  createNewBlob: CreateNewBlobHandler;
}

export const legacyBlobFilesClient: BlobFilesClient = {
  createNewBlob: async (route, body) => {
    const fetchOptions = await getPostRequestFetchOptions();
    const response = await fetch(`/blobs/new/${route.blobBucket}`, {
      ...fetchOptions,
      body: JSON.stringify(body),
    });

    const { createUrl, token } = await response.json();

    // HACK(mijames): local development browser requests should be sent to the webpack dev server
    // which then proxies requests to the web server (instead of directly to the web server)
    const parsedUrl = new URL(createUrl);
    if (parsedUrl.hostname === "localhost" && location.port === "8080") {
      parsedUrl.port = "8080";
    }

    return {
      token,
      createUrl: parsedUrl.toString(),
    };
  },
};
